import React from 'react'
import { IconButton, SvgIcon, Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'
import HapanaAiIcon from '@hapana/shared/web/styles/assets/svgs/hapana-ai-icon.svg'
import { useSupportAssistant } from '../support-assistant.hooks'
import { useFeatureFlag, FeatureFlagKeys } from '_hooks/useFeatureFlag'

interface SupportLauncherProps {
  topOffset?: number
  inline?: boolean
}

const SupportLauncher: React.FC<SupportLauncherProps> = ({ topOffset = 0, inline = false }) => {
  const { isOpen, setIsOpen, setActivePanel } = useSupportAssistant()
  const { t } = useTranslation('core')
  const { value: isEnabled } = useFeatureFlag(FeatureFlagKeys.SupportAssistantEnabled, {
    defaultValue: true,
  })

  if (!isEnabled) return null

  const toggleOpen = () => {
    if (!isOpen) {
      setActivePanel('assistant')
    }
    setIsOpen(!isOpen)
  }
  const label = t('supportAssistant.title')

  return (
    <Tooltip
      title={label}
      placement="left"
      slotProps={{
        tooltip: {
          sx: {
            bgcolor: 'background.paper',
            color: 'text.primary',
            border: '1px solid',
            borderColor: 'divider',
            fontSize: '0.75rem',
          },
        },
      }}
    >
      <IconButton
        onClick={toggleOpen}
        data-testid="support-launcher"
        aria-label={label}
        sx={{
          ...(inline
            ? {
                width: 36,
                height: 36,
                flexShrink: 0,
              }
            : {
                position: 'fixed',
                top: 16 + topOffset,
                right: 8,
                zIndex: 1000,
                width: 40,
                height: 40,
              }),
          opacity: isOpen ? 0 : 1,
          pointerEvents: isOpen ? 'none' : 'auto',
          transition: 'opacity 300ms ease-in-out, background-color 200ms ease-in-out',
          '&:hover': {
            backgroundColor: 'action.hover',
          },
        }}
      >
        <SvgIcon component={HapanaAiIcon} sx={{ fontSize: '1.5rem' }} />
      </IconButton>
    </Tooltip>
  )
}

export default SupportLauncher
